<template>
    <router-link
        v-slot="{ href, navigate, isExactActive }"
        :to="to"
        custom
    >
        <li class="mb-1 last:mb-0">
            <a
                class="block truncate text-gray-400 transition duration-150 hover:text-gray-200"
                :class="isExactActive && '!text-primary-additional-500'"
                :href="href"
                @click="navigate"
            >
                <span
                    class="lg:sidebar-expanded:opacity-100 text-sm font-medium duration-200 lg:opacity-0 2xl:opacity-100"
                    >{{ $t(label) }}</span
                >
            </a>
        </li>
    </router-link>
</template>

<script setup lang="ts">
defineProps({
    label: {
        type: String,
        required: true,
    },
    to: {
        type: String,
        required: true,
    },
})
</script>
